import { Avatar, Box } from '@mui/material';
import React from 'react';
import './AdminNavbar.css';
import { useUserExpended } from '../../../context/UserExpendedContext';
import { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { usePaymentExpanded } from '../../../context/PaymentExpandedContext';
import { useFeeSettingsExpended } from '../../../context/FeeSettingsContext';
import { axiosInstance } from '../../../utils/tokenUtils';
import { useProfile } from '../../../context/ProfileContext';
import { useNavigate } from 'react-router-dom';

const AdminNavbar = () => {
  const [auth] = useAuth();
  const { profile } = useProfile();
  const [rbacMe, setRbacMe] = useState(null);
  const navigate = useNavigate();
  const fetchedRef = useRef(false);

  const formatText = text => {
    if (!text) return '';
    const withSpaces = text.replace(/_/g, ' ');
    return withSpaces
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Fetch RBAC profile once with caching
  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    let cachedData = null;
    try {
      const cached = sessionStorage.getItem('rbac_admin_me');
      if (cached) {
        cachedData = JSON.parse(cached);
        setRbacMe(cachedData);
      }
    } catch (_) {}

    (async () => {
      try {
        const { data } = await axiosInstance.get('/admin/rbac/admin/me');
        setRbacMe(data);
        try {
          sessionStorage.setItem('rbac_admin_me', JSON.stringify(data));
        } catch (_) {}
      } catch (error) {
        console.error('Error fetching RBAC admin profile:', error);
        if (!cachedData) setRbacMe({ roles: [], permissions: [] });
      }
    })();
  }, []);

  const profileImage = profile?.profile_image || auth?.profile_image;
  const displayFirstName = profile?.first_name || auth?.first_name || '';
  const displayLastName = profile?.last_name || auth?.last_name || '';
  const roles = Array.isArray(rbacMe?.roles) ? rbacMe.roles : [];
  const roleDisplayMap = {
    user_onboarding: 'Talent Manager',
    talent_manager: 'Talent Manager',
    finance_officer: 'Finance Officer',
    operations_officer: 'Operations Officer',
    organisation_manager: 'Operations Officer',
    support_associate: 'Support Associate',
  };
  const displayRole = roles.length
    ? roles.map(role => roleDisplayMap[role] || formatText(role)).join(', ')
    : '';

  const getInitials = () => {
    const firstInitial = displayFirstName?.charAt(0)?.toUpperCase() || '';
    const lastInitial = displayLastName?.charAt(0)?.toUpperCase() || '';
    const initials = firstInitial + lastInitial;
    return initials || '';
  };

  return (
    <Box
      className="flex justify-end items-center pt-3 pb-4 pr-2 h-[8vh] admin-navbar"
      data-testid="admin-navbar"
    >
      <Box className="flex items-center gap-3 h-[80%]" data-testid="profile-container">
        <Box className="flex items-center gap-2" data-testid="profile-section">
          <Avatar
            data-testid="admin-avatar"
            src={profileImage && profileImage.startsWith('http') ? profileImage : undefined}
            sx={{
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              bgcolor: profileImage && profileImage.startsWith('http') ? 'transparent' : '#949DA6',
              color: '#FFFFFF',
              fontSize: '12px',
              fontWeight: 600,
            }}
            onClick={() => navigate('/admin/settings')}
            onError={e => {
              e.target.style.display = 'none';
            }}
          >
            {(!profileImage || !profileImage.startsWith('http')) &&
              (displayFirstName || displayLastName) &&
              getInitials()}
          </Avatar>
          <Box className="flex flex-col gap-1 h-[32px]">
            <Box className="admin-name">{displayFirstName ? formatText(displayFirstName) : ''}</Box>
            <Box className="admin-email">{displayRole ? formatText(displayRole) : ''}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminNavbar;
